namespace Client.Components

type StatusDot =
    | Green
    | Red
    | Grey

[<RequireQualifiedAccess>]
module StatusDot =
    let private baseUrl = "/images/status-dot"

    let toImageUrl (dot: StatusDot) =
        let file =
            match dot with
            | Green -> "dot_green.png"
            | Red -> "dot_red.png"
            | Grey -> "dot_grey.png"

        sprintf "%s/%s" baseUrl file

    let isActiveToImageUrl (isActive: bool) =
        let file =
            match isActive with
            | true -> "dot_green.png"
            | false -> "dot_red.png"

        sprintf "%s/%s" baseUrl file

[<RequireQualifiedAccess>]
module IsActiveComponent =
    let toText (isActive: bool) =
        match isActive with
        | true -> "Aktiv"
        | false -> "Inaktiv"